var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.type,{tag:"component",attrs:{"model":_vm.object,"on-success":_vm.send}})
}
var staticRenderFns = []

export { render, staticRenderFns }